<template>
  <v-snackbar v-model="errorMessage"
              top
              tile
              color="error"
              :timeout="4000"
              v-if="errorMessage">
    {{ errorMessage }}
  </v-snackbar>
</template>
<script>
export default {
  computed: {
    errorMessage: {
      get() {
        return this.$store.state.app.errorMessage
      },
      set(val) {
        this.$store.commit('setErrorMessage', val)
      },
    }
  }
}
</script>
